import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aa739a92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "app__title" }
const _hoisted_4 = { class: "text-justify event__title" }
const _hoisted_5 = { class: "text-justify description__text" }
const _hoisted_6 = { class: "text-justify" }
const _hoisted_7 = { class: "button__container" }
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.status)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 24,
                class: "text--center"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("program.program")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", null, [
            _createVNode(_component_el_timeline, { class: "timeline" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.program, (event, index) => {
                  return (_openBlock(), _createBlock(_component_el_timeline_item, {
                    key: index,
                    class: "timeline-item",
                    timestamp: $setup.convertDate(event.scheduledDates[0].startDate),
                    placement: "top",
                    color: $setup.colors[index + 1]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_card, {
                        class: _normalizeClass(['activity__card-' + $setup.type, "mt-1"])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_row, { class: "d-flex align-center text-justify" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, {
                                xs: 8,
                                sm: 4,
                                md: 4,
                                lg: 2,
                                xl: 2
                              }, {
                                default: _withCtx(() => [
                                  (event.speaker.picture)
                                    ? (_openBlock(), _createBlock(_component_el_avatar, {
                                        key: 0,
                                        fit: "fill",
                                        class: "image__config",
                                        src: 
                      event.speaker.picture == ''
                        ? require('@/assets/no_profile_image.png')
                        : event.speaker.picture
                    
                                      }, null, 8, ["src"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, {
                                xs: 16,
                                sm: 20,
                                md: 20,
                                lg: 22,
                                xl: 22
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("h3", _hoisted_4, _toDisplayString(event.eventName), 1),
                                  _createElementVNode("p", _hoisted_5, _toDisplayString(event.description), 1),
                                  _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.$t("program.registerCourse.speaker")) + " : " + _toDisplayString(event.speaker.speakerName), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["class"])
                    ]),
                    _: 2
                  }, 1032, ["timestamp", "color"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 24,
                class: "text--center"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_el_button, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.goTo('Program'))),
                      class: "secondary__color__button"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("program.fullProgram")), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8))
  ]))
}